// Meta (Facebook) Pixel — implementación directa con el snippet oficial.
// Se evita la librería react-facebook-pixel porque asume que existe un <script>
// en el documento (getElementsByTagName('script')[0]) y falla dentro del iframe
// de previsualización. Este enfoque inyecta el script de forma segura en <head>.

export const META_PIXEL_ID = '1025110903429235'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export const initPixel = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized || window.fbq) {
    // Ya inicializado: solo registramos la vista de página.
    if (window.fbq) window.fbq('track', 'PageView')
    return
  }
  initialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    let n: any
    let t: HTMLScriptElement
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const head =
      b.head || b.getElementsByTagName('head')[0] || b.documentElement
    head.appendChild(t)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID)
  window.fbq('track', 'PageView')
}

// Disparar cuando el usuario va al checkout
export const trackInitiateCheckout = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }
}
